.s{align-items:center;}